import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class RefreshService {
    private refreshOrderPayPendingSource = new Subject<void>();

    refreshOrderPayPending$ = this.refreshOrderPayPendingSource.asObservable();

    refreshOrderPayPending(): void {
        console.log("EMITINDO EVENTO");
        this.refreshOrderPayPendingSource.next();
    }
}
